<script setup>

</script>
<template>
    <div class="container-fluid">
        <slot name="containerContent">No content to display</slot>
    </div>
</template>